import { Injectable } from '@angular/core';
import { AppService } from '../appservice.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  constructor(private appservice: AppService) { }

  login(username, password, remember) {
    console.log(remember);
    var data = { "username": username, "password": password }
    return this.appservice.getRequestData("authenticate", data);
  }


  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }
}